import {
  AudienceFilterDto,
  ExpressionNodeQueryType,
} from "@intelligems/ig-types/dtos/audiences";
import { ExperiencePageTargetingFe } from "@intelligems/ig-types/fe-only/page-targeting";

export const getChosenCondition = (
  resource: ExperiencePageTargetingFe | AudienceFilterDto | undefined
) => {
  return resource !== undefined && resource.filterType
    ? resource.filterType
    : null;
};

export const containsQueryParam = (value: string) => {
  return value.includes("?");
};

export const getTargetKeyValue = (
  resource: ExperiencePageTargetingFe | AudienceFilterDto,
  resourceType: "queryParams" | "pageTargeting",
  key: keyof ExpressionNodeQueryType
) => {
  if (resourceType === "queryParams") {
    return (resource as AudienceFilterDto).expression![0].query![key];
  } else {
    return (resource as ExperiencePageTargetingFe)[key];
  }
};

export const getTargetPreviewDisplayValue = (
  filter: string | null | undefined,
  domain: string | undefined,
  value: string
) => {
  if (filter !== "equals" && filter !== "doesNotEqual") {
    return value;
  }

  if (value.startsWith("http")) {
    return value;
  }

  return `${domain}${domain?.endsWith("/") ? "" : "/"}${value}`;
};
